import { GetMtm } from './types';

export const normalizeGetMarketToMarket = (asset: GetMtm) => ({
  MtmActivated: asset ? asset.MtmActivated : false,
});
